import { TextField } from '@mui/material';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Header } from '../../../components/website/header';
import { urls } from '../../../services/endPoint';
import { api } from '../../../services/http';
import { SET_LOADING } from '../../../services/redux/reducers/loadingSlice';
import { userProfile } from '../../../services/redux/reducers/userSlice.ts';
import { useAppSelector } from '../../../services/redux/store';

const EditBankCard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userReducer = useAppSelector(state => state.userReducer.data);
  const [form, setForm] = useState({
    cardNumber: userReducer.cardNumber,
    shebaNumber: userReducer.shebaNumber,
    hesabNumber: userReducer.hesabNumber,
    bankName: userReducer.bankName
  });

  const submit = async () => {
    dispatch(SET_LOADING(true));

    const res = await api(urls.profileBank, {
      method: 'POST',
      body: {
        cardNumber: form.cardNumber,
        shebaNumber: form.shebaNumber,
        hesabNumber: form.hesabNumber,
        bankName: form.bankName,
      }
    }, true);

    if (res.code == 200) {
      toast('اطلاعات بانکی با موفقیت بروزرسانی شد.', { type: 'success' });
      dispatch(userProfile())
      navigate('/profile');
    } else {
      toast('مشکلی پیش آمده، لطفا مجددا امتحان کنید یا با اپراتور تماس بگیرید', { type: 'error' });
    }

    dispatch(SET_LOADING(false));
  };

  return (
    <>
      <Header onBack={() => navigate('/profile')}/>
      <main className="editProfile">
        <h3>ویرایش اطلاعات بانکی</h3>
        <TextField
          size="small"
          onChange={(input) => setForm(prev => ({
            ...prev,
            cardNumber: input.target.value
          }))}
          value={form?.cardNumber}
          fullWidth
          label="شماره کارت"
          variant="outlined"
          className="textInput"
        />
        <TextField
          size="small"
          onChange={(input) => setForm(prev => ({
            ...prev,
            shebaNumber: input.target.value
          }))}
          value={form?.shebaNumber}
          fullWidth
          label="شماره شبا"
          variant="outlined"
          className="textInput"
        />
        <TextField
          size="small"
          value={form?.hesabNumber}
          fullWidth
          onChange={(input) => setForm(prev => ({
            ...prev,
            hesabNumber: input.target.value
          }))}
          label="شماره حساب"
          variant="outlined"
          className="textInput"
        />
        <TextField
          size="small"
          value={form?.bankName}
          onChange={(input) => setForm(prev => ({
            ...prev,
            bankName: input.target.value
          }))}
          fullWidth
          name="bankName"
          label="نام بانک"
          variant="outlined"
          className="textInput"
        />
        <button className="confirmButton" onClick={submit}>
          ثبت
        </button>
      </main>
    </>
  );
};

export default EditBankCard;
